module.exports = __webpack_public_path__ + "static/img/4.80ce0a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/4.jpg
// module id = oPwJ
// module chunks = 2